import React, { useState, useEffect } from "react";
import { Col } from "react-materialize";
import CardComponent from "../material/CardComponent";
import { getSite } from '../../utils/site';
import featureSwitchApi from "../../api/featureSwitchApi";

const DashboardMat = (props) => {
  const [cardsToShow, setCardsToShow] = useState([]);
  const { cardInfo, user } = props;

  useEffect(()=>{
    async function prepareDashboard() {
      const dashboard = [];

      for (let i = 0; i < cardInfo.length; i++) {
        const card = cardInfo[i];

        if (typeof card.users === "undefined") {
          card.users = [];
        }

        const isFeatureOn = await checkFeatureSwitch(card.featureFlag);
        const isAuthorized = (card.roles.includes(user.role) || card.users.includes(user.email)) &&card.sites.includes(getSite());

        if (isAuthorized && isFeatureOn) {
          dashboard.push(card);
        }
      }

      setCardsToShow(dashboard);
    }

    prepareDashboard();
  },[cardInfo, user])


  async function checkFeatureSwitch(featureFlag){
    if(featureFlag)
    {
      const result =  await featureSwitchApi.getFeatureSwitch(featureFlag);
      return result.data.value;
    }

    return true;
  }

  return (
    <>
      {cardsToShow.map((card, i) => (
        <Col m={4} s={12} key={i.toString()}>
          <CardComponent
            idCard={card.idCard}
            toLink={card.toLink}
            keyCard={card.keyCard}
            textSpan={card.textSpan}
            textAction={card.textAction}
            text={card.text}
          />
        </Col>
      ))}
    </>
  )
}
export default DashboardMat